// GeneralInfo.js
import { Link } from "react-router-dom";
import React, {useState} from "react";
import { useFormik, FieldArray, FormikProvider } from "formik";
import * as Yup from "yup";
import './ApplyAffilates.css';
import Model from "../../../utils/model";
const ApplyAffilates = () => {
      const [showModal, setShowModal] = useState(false);
          const [modalContent, setModalContent] = useState({
            icon: "/img/check_green.svg", // Replace with your desired icon
            header: "We've Recived Your Request",
            body: "Thank you for applying to become a Rentid affiliate! Our team will review your information and reach out if we’re a good fit. Let’s drive innovation together!",
            button:'Got it',
            handleSuccess: () => {
              console.log("Modal button clicked!"); 
              window.location.href = '/rentacademy';
          }
            
          });
        

    const formik = useFormik({
        initialValues: {
          first_name: "",
          email_address: "",
          phone_number: "",
         socialMediaLinks: [{ socialMedia: "", followers: "" }],
          Monthlyreach: "",
          Engagement : "",
          Websitelink: "",
          UniqueMonthly:"" ,
          Subscribers:"",
          PreviousBrand :"",
          reason:""
        },

        // validation start ..
        validationSchema: Yup.object({
          first_name: Yup.string().required("Full name is required"),
          email_address: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
          phone_number: Yup.string()
         // .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
        .required("Phone number is required"),
          socialMediaLinks: Yup.array().of(
            Yup.object({
              socialMedia: Yup.string().required("Social media link is required"),
              followers: Yup.number()
                .typeError("Must be a number")
                .required("Follower count is required"),
            })
          ),
          Monthlyreach: Yup.number()
          .typeError("Must be a valid number")
          .required("Monthly reach is required"),
          Engagement: Yup.number()
          .typeError("Must be a valid number")
          .required("Engagement  is required"),
          Websitelink: Yup.string().required("Website link  is required"),
          UniqueMonthly: Yup.number()
          .typeError("Must be a valid number")
          .required("Unique Monthly  is required"),
          Subscribers: Yup.number()
          .typeError("Must be a valid number")
          .required("Subscribers  is required"),
         // PreviousBrand: Yup.string().required("Previous Brand is required"),
         // reason: Yup.string().required("Reason is required"),
        }),

        onSubmit: (values) => {
            console.log("Form values:", values);
            setShowModal(true);
          },
      });
  return (
 <>
    <section className="headerApply">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="headerApplyInner">
                    <a href="/rentacademy" alt="Go to Rent Academy Page"><img src="/img/r-logo-new.svg" alt="Rentid Logo" className="img-fluid"/></a>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/rentacademy">Rentacademy</a>
                            </li>
                            <img className="" src="/img/arrow-right-nav.svg" alt="arrow"/>
                            <li className="breadcrumb-item active" aria-current="page">Open Call for Creators</li>
                        </ol>
                    </nav>
                </div>
                </div>
            </div>
        </div>
    </section>

    <section className="applyAcdemyMain applyAffiliateMain">
        <div className="container">
            <div className="academyFormOuter">
                <div className="academyFormHeading">
                    <Link to='/rentacademy'> <img src="/img/back.svg" className="img-fluid" alt="back" /></Link> 
                    <h1>Apply to Become an Affiliate</h1>
                </div>
                
                <div className="row justify-content-center">
                    <div className="col-lg-12 col-md-12">
                    
                        <div className="academyForm">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label for="firstName" className="form-label">Full name <span className="required">*</span>
                                        </label>
                                        <input name="first_name"  type="text" id="first_name" placeholder="Enter your full name" className="form-control" 
                                         {...formik.getFieldProps("first_name")}
                                                />
                                        {formik.touched.first_name && formik.errors.first_name && (
                                            <div className="text-danger">{formik.errors.first_name}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label for="email" className="form-label">Email address <span className="required">*</span>
                                        </label>
                                        <input name="email_address" required="" type="email" id="email_address" placeholder="Enter your email address" className="form-control"  {...formik.getFieldProps("email_address")}
                                        />
                                        {formik.touched.email_address && formik.errors.email_address && (
                                            <div className="text-danger">{formik.errors.email_address}</div>
                                        )}
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label for="phone_number" className="form-label">Phone Number <span className="required">*</span>
                                        </label>
                                        <div className="row border align-items-center countryflag m-0">
                                            <div className="flagLeft countrycode">
                                                <img src="/img/us.svg" className="img-fluid me-2" alt="Country Flag"/>
                                                <span>+1</span>
                                            </div>
                                            <div className="flagRight">
                                                <input name="phone_number" id="phone_number" placeholder="XXX-XXX-XXX" formatcharacters="[object Object]" className="form-control"
                                                {...formik.getFieldProps("phone_number")}
                                                    />
                                            </div>
                                        </div>
                                        {formik.touched.phone_number && formik.errors.phone_number && (
                                            <div className="text-danger">{formik.errors.phone_number}</div>
                                        )}
                                    </div>
                                </div>

                      <div className="col-md-12">
                        <div className="mb-3">

                          <FormikProvider value={formik}>
                            <FieldArray
                              name="socialMediaLinks"
                              render={(arrayHelpers) => (
                                <div>
                                  {formik.values.socialMediaLinks.map((link, index) => (
                                    <div key={index} className="socialMediaForm">
                                      <div className="socialMediaFormLeft">
                                        <label className="form-label">
                                          Social Media Channel
                                          <img
                                            src="/img/tooltip_icon.svg"
                                            width="20px"
                                            height="20px"
                                            className="tooltip_1"
                                            alt="Tooltip"
                                          />
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          placeholder="Social media link"
                                          className="form-control"
                                          {...formik.getFieldProps(`socialMediaLinks.${index}.socialMedia`)}
                                        />
                                        {formik.touched.socialMediaLinks?.[index]?.socialMedia &&
                                          formik.errors.socialMediaLinks?.[index]?.socialMedia && (
                                            <div className="text-danger">
                                              {formik.errors.socialMediaLinks[index].socialMedia}
                                            </div>
                                          )}
                                      </div>

                                      <div className="socialMediaFormRight">
                                        <label className="form-label labelFollwer">
                                          Follower Counts
                                        </label>
                                        <input
                                          type="text"
                                          placeholder="(e.g. 2000)"
                                          className="form-control"
                                          {...formik.getFieldProps(`socialMediaLinks.${index}.followers`)}
                                        />
                                        {formik.touched.socialMediaLinks?.[index]?.followers &&
                                          formik.errors.socialMediaLinks?.[index]?.followers && (
                                            <div className="text-danger">
                                              {formik.errors.socialMediaLinks[index].followers}
                                            </div>
                                          )}
                                      </div>

                                     
                                        <div className="socialMediaFormIcon">
                                          <Link
                                            onClick={(e) => {
                                              e.preventDefault();
                                              arrayHelpers.remove(index); // Remove row
                                            }}
                                            
                                          >
                                            <img src="/img/delete_icon.svg" className="img-fluid" alt="Delete" />

                                          </Link>

                                        </div>
                                    
                                    </div>
                                  ))}

                                  <div className="col-md-12">
                                    <div className="addNewBtn">
                                      <Link type="button" className="btn btnTransparent_21" onClick={() => arrayHelpers.push({ socialMedia: "", followers: "" })}>
                                        <img width="24px" height="24px" src="/img/rentacademy/plus.svg" alt="icon" /> Add New Row
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          </FormikProvider>
                        </div>
                      </div>
                      
                                {/* <div className="col-md-12">
                                    <div className="mb-3">
                                        
                                    <FormikProvider value={formik}>
                                    <FieldArray
                                    name="socialMediaLinks"
                                    render={(arrayHelpers) => (
                                        <div>
                                        {formik.values.socialMediaLinks.map((link, index) => (
                                            <div key={index} className="socialMediaForm">
                                            <div className="socialMediaFormLeft">
                                                <label className="form-label">
                                                Social Media Channel
                                                <img
                                                    src="/img/tooltip_icon.svg"
                                                    width="20px"
                                                    height="20px"
                                                    className="tooltip_1"
                                                    alt="Tooltip"
                                                />
                                                <span className="required">*</span>
                                                </label>
                                                <input
                                                type="text"
                                                placeholder="Social media link"
                                                className="form-control"
                                                {...formik.getFieldProps(`socialMediaLinks.${index}.socialMedia`)}
                                                />
                                                {formik.touched.socialMediaLinks?.[index]?.socialMedia &&
                                                formik.errors.socialMediaLinks?.[index]?.socialMedia && (
                                                    <div className="text-danger">
                                                    {formik.errors.socialMediaLinks[index].socialMedia}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="socialMediaFormRight">
                                                <label className="form-label labelFollwer">
                                                Follower Counts
                                                </label>
                                                <input
                                                type="text"
                                                placeholder="(e.g. 2000)"
                                                className="form-control"
                                                {...formik.getFieldProps(`socialMediaLinks.${index}.followers`)}
                                                />
                                                {formik.touched.socialMediaLinks?.[index]?.followers &&
                                                formik.errors.socialMediaLinks?.[index]?.followers && (
                                                    <div className="text-danger">
                                                    {formik.errors.socialMediaLinks[index].followers}
                                                    </div>
                                                )}
                                            </div>
                                            {index > 0 && ( 
                                            <div className="socialMediaFormIcon">
                                           
                                                <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    arrayHelpers.remove(index); // Remove row
                                                }}
                                                >
                                                <img src="/img/delete_icon.svg" className="img-fluid" alt="Delete" />
                                                </a>
                                             
                                            </div>
                                        )}
                                            </div>
                                        ))}

                                        <div className="col-md-12">
                                       <div className="addNewBtn">
                                        <a type="button" className="btn btnTransparent_21" onClick={() => arrayHelpers.push({ socialMedia: "", followers: "" })}>
                                            <img width="24px" height="24px" src="/img/rentacademy/plus.svg" alt="icon"/> Add New Row 
                                        </a>
                                    </div>
                                </div>
                                        </div>
                                    )}
                                    />
                                </FormikProvider>

                                    </div>
                                </div> */}

                               


                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label for="companyName" className="form-label">Monthly reach across all channels
                                        <img src="/img/tooltip_icon.svg" width="20px" height="20px" className="tooltip_1" alt="Tooltip"/>
                                        </label>
                                        <input name="companyName" required="" type="text"  placeholder="Enter reach number" className="form-control"{...formik.getFieldProps("Monthlyreach")}    
                                            />
                                            {formik.touched.Monthlyreach && formik.errors.Monthlyreach && (
                                            <div className="text-danger">{formik.errors.Monthlyreach}</div>
                                            )}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label for="companyName" className="form-label">Engagement Metrics 
                                        <img src="/img/tooltip_icon.svg" width="20px" height="20px" className="tooltip_1" alt="Tooltip"/>
                                        </label>
                                        <input required="" type="text"  placeholder="Enter engagement number" className="form-control" {...formik.getFieldProps("Engagement")}    
                                            />
                                            {formik.touched.Engagement && formik.errors.Engagement && (
                                            <div className="text-danger">{formik.errors.Engagement}</div>
                                            )}
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label  className="form-label">Website/Blog Link</label>
                                        <input  required="" type="text"  placeholder="Paste your website or blog link" className="form-control"  {...formik.getFieldProps("Websitelink")}    
                                            />
                                            {formik.touched.Websitelink && formik.errors.Websitelink && (
                                            <div className="text-danger">{formik.errors.Websitelink}</div>
                                            )}
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label  className="form-label">Unique Monthly Visitors 
                                            <img src="/img/tooltip_icon.svg" width="20px" height="20px" className="tooltip_1" alt="Tooltip"/>
                                        </label>
                                        <input  required="" type="text"  placeholder="(e.g. 2000)" className="form-control" {...formik.getFieldProps("UniqueMonthly")}    
                                            />
                                            {formik.touched.UniqueMonthly && formik.errors.UniqueMonthly && (
                                            <div className="text-danger">{formik.errors.UniqueMonthly}</div>
                                            )}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label for="companyName" className="form-label">Subscribers/Newsletter Members
                                            <img src="/img/tooltip_icon.svg" width="20px" height="20px" className="tooltip_1" alt="Tooltip"/>
                                        </label>
                                        <input name="companyName" required="" type="text"  placeholder="(e.g. 2000)" className="form-control"{...formik.getFieldProps("Subscribers")}    
                                            />
                                            {formik.touched.Subscribers && formik.errors.Subscribers && (
                                            <div className="text-danger">{formik.errors.Subscribers}</div>
                                            )}
                                    </div>
                                </div>
                            </div>
                          

                            {/* START academyForm */}
                            <div className="academyFormClick">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label for="email" className="form-label">Previous Brand Partnerships</label>
                                            <textarea className="form-control" rows="3" placeholder="List any previous brand partnerships (optional)" {...formik.getFieldProps("PreviousBrand")}    
                                            >
                                            </textarea>
                                            {/* {formik.touched.PreviousBrand && formik.errors.PreviousBrand && (
                                            <div className="text-danger">{formik.errors.PreviousBrand}</div>
                                            )} */}
                                            <span className="charactersLimit">0/500 characters.</span>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label for="email" className="form-label">Why Do You Want to Partner with Rentid?</label>
                                            <textarea className="form-control" rows="3" placeholder="Tell us why you're a great fit for Rentid (optional)"  {...formik.getFieldProps("reason")}></textarea>
                                            {/* {formik.touched.reason && formik.errors.reason && (
                                            <div className="text-danger">{formik.errors.reason}</div>
                                            )} */}
                                            <span className="charactersLimit">0/500 characters.</span>

                                        </div>
                                    </div>
               
                                </div>
                            </div>
                            <div className="applyBottom">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-4">
                                            <a className="btn exitBtn"href="/rentacademy" >Cancel</a>
                                            {/* <button type="button" className="btn exitBtn">Cancel</button> */}
                                        </div>
                                        <div className="col-8 btn-continue text-end d-flex gap-2 align-items-center justify-content-end">
                                            <div className="footer-btn-sec">
                                                <button type="submit" className="btn btnBlue">Submit Form</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </form>
                            {/* END academyForm */}

                    
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

   {/* Modal */}
   <Model
        prop={{
          show: showModal,
          setShow: setShowModal,
          content: modalContent,
        }}
      />
 
 </>
)
}

export default ApplyAffilates;
